export enum DanceEventSearchStatusEnum {
  NEW = 'NEW',
  POPULAR = 'POPULAR',
  SALE_ENDS_SOON = 'SALE_ENDS_SOON'
}
